import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import {
  getDeliveryAcceptanceData,
  getDeliveryAndQualityKpiCardData,
  getDeliveryEffectiveNess,
  getDeliveryFillRateData,
  getDeliveryRiseData,
  getOrderFullFillment,
  getOTIFData,
  getQualityDefectivePPMData,
  getQualityKpiCardData,
  getQualityRiskScoreGraphData,
  getSupplierLeadTime,
} from './delivery-and-quality.async'

const initialState = {
  supplierDQKpiCardLoader: false,
  supplierDQKpiCardData: {},
  supplierDQDeliveryAcceptanceDataLoader: false,
  supplierDQDeliveryAcceptanceData: {},
  supplierDQLeadTimeLoader: false,
  supplierDQLeadTimeData: [],
  supplierDQDeliveryEffectiveNessLoader: false,
  supplierDQDeliveryEffectiveNessData: [],
  supplierDQOrderFullFillmentLoader: false,
  supplierDQOrderFullFillmentData: [],
  supplierDeliveryRiseLoader: false,
  supplierDeliveryRiseData: [],
  supplierDeliveryOTIFLoader: false,
  supplierDeliveryOTIFData: [],
  supplierDeliveryFillRateLoader: false,
  supplierDeliveryFillRateData: [],
  supplierQualityKpiLoader: false,
  supplierQualityKpiData: [],
  supplierQualityRiskScoreGraphLoader: false,
  supplierQualityRiskScoreGraphData: [],
  supplierQualityDefectivePPMLoader: false,
  supplierQualityDefectivePPMData: [],
}

const DeliveryAndQualityReducer = createSlice({
  name: 'DeliveryAndQualityReducer',
  initialState,
  reducers: {
    emptyDeliveryAndQualityReducer: (state) => {
      state.supplierDQKpiCardData = {}
      state.supplierDQDeliveryAcceptanceData = {}
      state.supplierDQLeadTimeData = []
      state.supplierDQDeliveryEffectiveNessData = []
      state.supplierDQOrderFullFillmentData = []
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getDeliveryAndQualityKpiCardData.pending), (state) => {
      state.supplierDQKpiCardLoader = true
    })
    builder.addMatcher(isAnyOf(getDeliveryAndQualityKpiCardData.fulfilled), (state, action) => {
      state.supplierDQKpiCardLoader = false
      state.supplierDQKpiCardData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getDeliveryAndQualityKpiCardData.rejected), (state) => {
      state.supplierDQKpiCardLoader = false
    })

    builder.addMatcher(isAnyOf(getDeliveryAcceptanceData.pending), (state) => {
      state.supplierDQDeliveryAcceptanceDataLoader = true
    })
    builder.addMatcher(isAnyOf(getDeliveryAcceptanceData.fulfilled), (state, action) => {
      state.supplierDQDeliveryAcceptanceDataLoader = false
      state.supplierDQDeliveryAcceptanceData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getDeliveryAcceptanceData.rejected), (state) => {
      state.supplierDQDeliveryAcceptanceDataLoader = false
    })

    builder.addMatcher(isAnyOf(getSupplierLeadTime.pending), (state) => {
      state.supplierDQLeadTimeLoader = true
    })
    builder.addMatcher(isAnyOf(getSupplierLeadTime.fulfilled), (state, action) => {
      state.supplierDQLeadTimeLoader = false
      state.supplierDQLeadTimeData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSupplierLeadTime.rejected), (state) => {
      state.supplierDQLeadTimeLoader = false
    })

    builder.addMatcher(isAnyOf(getDeliveryEffectiveNess.pending), (state) => {
      state.supplierDQDeliveryEffectiveNessLoader = true
    })
    builder.addMatcher(isAnyOf(getDeliveryEffectiveNess.fulfilled), (state, action) => {
      state.supplierDQDeliveryEffectiveNessLoader = false
      state.supplierDQDeliveryEffectiveNessData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getDeliveryEffectiveNess.rejected), (state) => {
      state.supplierDQDeliveryEffectiveNessLoader = false
    })

    builder.addMatcher(isAnyOf(getOrderFullFillment.pending), (state) => {
      state.supplierDQOrderFullFillmentLoader = true
    })
    builder.addMatcher(isAnyOf(getOrderFullFillment.fulfilled), (state, action) => {
      state.supplierDQOrderFullFillmentLoader = false
      state.supplierDQOrderFullFillmentData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getOrderFullFillment.rejected), (state) => {
      state.supplierDQOrderFullFillmentLoader = false
    })

    builder.addMatcher(isAnyOf(getDeliveryRiseData.pending), (state) => {
      state.supplierDeliveryRiseLoader = true
    })
    builder.addMatcher(isAnyOf(getDeliveryRiseData.fulfilled), (state, action) => {
      state.supplierDeliveryRiseLoader = false
      state.supplierDeliveryRiseData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getDeliveryRiseData.rejected), (state) => {
      state.supplierDeliveryRiseLoader = false
    })

    builder.addMatcher(isAnyOf(getOTIFData.pending), (state) => {
      state.supplierDeliveryOTIFLoader = true
    })
    builder.addMatcher(isAnyOf(getOTIFData.fulfilled), (state, action) => {
      state.supplierDeliveryOTIFLoader = false
      state.supplierDeliveryOTIFData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getOTIFData.rejected), (state) => {
      state.supplierDeliveryOTIFLoader = false
    })

    builder.addMatcher(isAnyOf(getDeliveryFillRateData.pending), (state) => {
      state.supplierDeliveryFillRateLoader = true
    })
    builder.addMatcher(isAnyOf(getDeliveryFillRateData.fulfilled), (state, action) => {
      state.supplierDeliveryFillRateLoader = false
      state.supplierDeliveryFillRateData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getDeliveryFillRateData.rejected), (state) => {
      state.supplierDeliveryFillRateLoader = false
    })

    builder.addMatcher(isAnyOf(getQualityKpiCardData.pending), (state) => {
      state.supplierQualityKpiLoader = true
    })
    builder.addMatcher(isAnyOf(getQualityKpiCardData.fulfilled), (state, action) => {
      state.supplierQualityKpiLoader = false
      state.supplierQualityKpiData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getQualityKpiCardData.rejected), (state) => {
      state.supplierQualityKpiLoader = false
    })

    builder.addMatcher(isAnyOf(getQualityRiskScoreGraphData.pending), (state) => {
      state.supplierQualityRiskScoreGraphLoader = true
    })
    builder.addMatcher(isAnyOf(getQualityRiskScoreGraphData.fulfilled), (state, action) => {
      state.supplierQualityRiskScoreGraphLoader = false
      state.supplierQualityRiskScoreGraphData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getQualityRiskScoreGraphData.rejected), (state) => {
      state.supplierQualityRiskScoreGraphLoader = false
    })

    builder.addMatcher(isAnyOf(getQualityDefectivePPMData.pending), (state) => {
      state.supplierQualityDefectivePPMLoader = true
    })
    builder.addMatcher(isAnyOf(getQualityDefectivePPMData.fulfilled), (state, action) => {
      state.supplierQualityDefectivePPMLoader = false
      state.supplierQualityDefectivePPMData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getQualityDefectivePPMData.rejected), (state) => {
      state.supplierQualityDefectivePPMLoader = false
    })
  },
})

export const { emptyDeliveryAndQualityReducer } = DeliveryAndQualityReducer.actions
export default DeliveryAndQualityReducer.reducer
